var _path, _path2, _path3, _line, _line2, _line3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgControlCmdHandRotateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 33,
    viewBox: "0 0 37 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 4.89062L12.5 2.39062L10 0.390625",
    stroke: "#4ED064"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 28.3906L10.5 20.6577L15.643 10.3906",
    stroke: "#DFD8D0",
    strokeMiterlimit: 3.99393
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 28.3906L25.5 20.6577L20.357 10.3906",
    stroke: "#DFD8D0",
    strokeMiterlimit: 3.99393
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 11.5,
    y1: 10.4404,
    x2: 24.5,
    y2: 10.4404,
    stroke: "#4ED064"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 1.39063,
    x2: 16,
    y2: 10.3906,
    stroke: "#4ED064"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 1.39063,
    x2: 20,
    y2: 10.3906,
    stroke: "#4ED064"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2.39062C5.87258 2.39062 0.5 5.52463 0.5 9.39062C0.5 12.5464 4.0799 15.2144 9 16.0882",
    stroke: "#4ED064"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 27.5879L24.5 30.0879L27 32.0879",
    stroke: "#4ED064"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 30.0879C31.1274 30.0879 36.5 26.9539 36.5 23.0879C36.5 19.9321 32.9201 17.2641 28 16.3903",
    stroke: "#4ED064"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlCmdHandRotateIcon);
export default __webpack_public_path__ + "static/media/control-cmd-hand-rotate-icon.c191259de721286520bdff87a58f61a0.svg";
export { ForwardRef as ReactComponent };